// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import Request from "Components/Request";
import Paginator from "Components/Paginator";
import SearchForm from "../SearchForm";
import Spinner from "Components/Spinner";

// selectors
import { getIsRequesting, getCurrentEnvironment } from "Selectors/app";
import { getUserBreadcrumbs, getCurrentPage, getBreadcrumbsCount, getPageSize, getFiltersMap } from "../../selectors";

// actions
import { changePage, getBreadcrumbs, updateFilter } from "../../actions";

// css
import css from "./Breadcrumbs";

class BreadcrumbsComponent extends React.Component {
	static propTypes = {
		isRequesting: PropTypes.bool.isRequired,
		changePage: PropTypes.func.isRequired,
		pageSize: PropTypes.number.isRequired,
		currentPage: PropTypes.number.isRequired,
		breadcrumbsCount: PropTypes.number.isRequired,
		breadcrumbs: PropTypes.instanceOf(List).isRequired,
		updateFilter: PropTypes.func.isRequired,
		getBreadcrumbs: PropTypes.func.isRequired,
		filters: PropTypes.object.isRequired,
	};

	componentDidMount = () => {};

	changePage = (page) => {
		this.props.changePage(page);
	};

	handleKeyPress = (event) => {
		const filtersExist =
			this.props.filters.url.length || this.props.filters.startTime.length || this.props.filters.endTime.length;
		if (event.key === "Enter" && filtersExist) {
			this.props.getBreadcrumbs();
		}
	};

	render = () => {
		const { pageSize, breadcrumbs, breadcrumbsCount, currentPage, isRequesting, filters } = this.props;
		const pageCount = Math.ceil(breadcrumbsCount / pageSize);
		return (
			<div className={css.main} onKeyUp={this.handleKeyPress}>
				<div testid="wrapper" className={css.wrapper}>
					<SearchForm
						url={filters.url}
						startTime={filters.startTime}
						endTime={filters.endTime}
						updateFilter={(name, value) => this.props.updateFilter(name, value)}
						getBreadcrumbs={this.props.getBreadcrumbs}
					/>
					<div className={css.info}>
						<div>{isRequesting ? <Spinner /> : breadcrumbsCount}</div>
						<div>&nbsp;Breadcrumb{breadcrumbsCount !== 1 && "s"} found</div>
					</div>
					<div className={css.breadcrumbList}>
						{breadcrumbs.map((request) => (
							<div key={request.get("id")} className={css.requestWrapper}>
								<Request request={request} />
							</div>
						))}

						<div className={css.paginatorWrapper}>
							<Paginator
								isRequesting={isRequesting}
								onClick={this.changePage}
								pageCount={pageCount}
								currentPage={currentPage}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => {
	const filters = getFiltersMap(state);
	return {
		filters: {
			url: filters.get("url", ""),
			startTime: filters.get("startTime", ""),
			endTime: filters.get("endTime", ""),
		},
		pageSize: getPageSize(state),
		currentPage: getCurrentPage(state),
		breadcrumbs: getUserBreadcrumbs(state),
		breadcrumbsCount: getBreadcrumbsCount(state),
		environment: getCurrentEnvironment(state),
		isRequesting: getIsRequesting(state, "REQUESTS:GET"),
	};
};

const mapDispatchToProps = (dispatch) => ({
	changePage: (pageNumber) => dispatch(changePage(pageNumber)),
	updateFilter: (name, value) => dispatch(updateFilter(name, value)),
	getBreadcrumbs: () => dispatch(getBreadcrumbs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsComponent);
